import { render, staticRenderFns } from "./TeamDetailActionsDropdown.vue?vue&type=template&id=51adf0c0&"
import script from "./TeamDetailActionsDropdown.vue?vue&type=script&lang=js&"
export * from "./TeamDetailActionsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports